export default __webpack_public_path__ + "ea3a4fd301f676685d96da30d8e17cd4.png";